/* eslint-disable */
/**
 * Neptune TP API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddDocumentCommand
 */
export interface AddDocumentCommand {
    /**
     * 
     * @type {string}
     * @memberof AddDocumentCommand
     */
    mediaCategoryId: string;
    /**
     * 
     * @type {string}
     * @memberof AddDocumentCommand
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddDocumentCommand
     */
    fileUploadId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddDocumentCommand
     */
    remoteFileUrl?: string | null;
}

export function AddDocumentCommandFromJSON(json: any): AddDocumentCommand {
    return {
        'mediaCategoryId': json['mediaCategoryId'],
        'name': json['name'],
        'fileUploadId': !exists(json, 'fileUploadId') ? undefined : json['fileUploadId'],
        'remoteFileUrl': !exists(json, 'remoteFileUrl') ? undefined : json['remoteFileUrl'],
    };
}

export function AddDocumentCommandToJSON(value?: AddDocumentCommand | null): any {
    if (value == undefined) {
        return undefined;
    }
    return {
        'mediaCategoryId': value.mediaCategoryId,
        'name': value.name,
        'fileUploadId': value.fileUploadId,
        'remoteFileUrl': value.remoteFileUrl,
    };
}


